import React from "react";
import { useSelector } from "react-redux";
import RequestRow from "./requestRow";
import moment from "moment";
import { useEffect } from "react";

const AskRequests = props => {

  const {
    filters,    
    setRequests,
    reminds,
    setReminds
  } = props;

  const surveys = useSelector(state => state.ask.surveys);
  const drafts = useSelector(state => state.ask.drafts);

  useEffect(() => {
    setRequests(items);
  }, [surveys.list, filters]);

  let items = [];
  let listSurveys = surveys.list;
  /* listSurveys =
    this.props.surveys.list.length > 0
        ? this.props.surveys.list
        : listSurveys;*/
  if (drafts && drafts.list) {
    listSurveys = listSurveys.concat(drafts.list);
  }
  if (filters.sort.field) {
    if (filters.sort.direction === "desc") {
      listSurveys.sort((a, b) =>
        moment(b[filters.sort.field]) -
                moment(a[filters.sort.field]));
    } else {
      listSurveys.sort((a, b) =>
        moment(a[filters.sort.field]) -
                moment(b[filters.sort.field]));
    }
  }
  let cn = 0;
  listSurveys.map(request => {
    let checkAdd = true;
    cn++;
    if (filters.type !== "") {
      if (
        filters.type === "toRead" &&
            (request.managerId === "" ||
                request.itemId === "" ||
                (request.managerId !== "" &&
                request.itemId !== "" &&
                (request.managerViewedAt || !request.completedAt)))
      ) {
        checkAdd = false;
      }
      if (filters.type === "toSend" && request.itemId) {
        checkAdd = false;
      }
      if (
        filters.type === "toFill" &&
            (!request.itemId || request.completedAt || !request.createdAt)
      ) {
        checkAdd = false;
      }
      if (filters.type === "filled" && !request.completedAt) {
        checkAdd = false;
      }
      if (filters.type === "itemToRead" && (request.itemViewedAt || request.completedAt)) {
        checkAdd = false;
      }
    }
    if (
      filters.company !== "" &&
        filters.company !== request.itemId
    ) {
      checkAdd = false;
    }
    if (
      filters.title !== "" &&
        request.title
          .toLowerCase()
          .indexOf(filters.title.toLowerCase()) === -1
    ) {
      checkAdd = false;
    }
    if (checkAdd) {
      items.push(<RequestRow
        key={"askList-panel-reply_" + (request.answerId || cn)}        
        request={request}
        reminds={reminds}
        setReminds={setReminds}
      />);
    }
    return null;
  });

  return items;
};

export default AskRequests;